// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5); /* 흐린 배경 */
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.modal {
    background: #fff;
    width: 70%;
    max-width: 1300px;
    height: 80%;
    max-height: 720px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
    overflow: hidden;
    animation: slide-up-fade-in 0.3s ease-out forwards;
}

.modal .header {
    position: sticky;
    top: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #414141;
    color: white;
    font-size: 17.6px;
    padding: 0 16px;
}

.modal .close {
    line-height: 150%;
    height: 21px;
    transform: scale(2);
    cursor: pointer;
}

.modal .close:hover {
    transform: scale(1.9);
    cursor: pointer;
}

.modal .content {
    text-align: left;
    padding: 16px;
    font-size: 13px;
    line-height: 160%;
    overflow-y: scroll;
    max-height: calc(100% - 90px);
}

.modal .content .modal_smith_logo {
    width: 261px;
}

.modal .content .caution {
    font-size: 12px;
    margin: 0;
    color: red;
    padding-left: 1.6px;
}

@keyframes slide-up-fade-in {
    from {
        transform: translateY(30px);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.modal-details {
    display: grid;
    row-gap: 12.8px;
    column-gap: 16px;
    grid-template-columns: 1fr 4fr;
    align-items: center;
}

.modal-details .modal-details-category {
    background-color: #F5F5F5;
    padding: 6.4px;
    margin: 0 0 auto 0;
}

.modal-inputs select, .modal-details select {
    margin-right: 16px;
}

.modal-inputs {
    display: grid;
    width: 100%;
    grid-template-columns: 1fr 6fr;
    row-gap: 12.8px;
    column-gap: 25.6px;
    align-items: center;
}

.modal-inputs .modal-inputs-category {
    background-color: #F5F5F5;
    padding: 4.8px 9.6px;
    margin: 0 0 auto 0;
}

.modal-inputs input, .modal-details input {
    width: -moz-fit-content;
    width: fit-content;
    height: 22.4px;
    padding: 3px 4px;
    border: 1px solid #dcdcdc;
}

.modal-inputs select, .modal-details select {
    width: max-content;
    min-width: 150px;
    height: 32px;
    padding: 2.4px 4.8px;
    border: 1px solid #dcdcdc;
}

.modal-inputs textarea, .modal-details textarea {
    resize: none;
    border: 1px solid #dcdcdc;
    padding: 4.8px;
}

@media screen and (max-width: 900px) {
    .modal {
        width: 100%;
    }
}

@media screen and (max-width: 600px) {
    .modal {
        height: 60%;
    }

    .modal .header {
        font-size: 16px;
    }

    .modal .content .modal_smith_logo {
        width: 180px;
    }

    .modal .content .caution {
        font-size: 11px;
    }

    .modal-inputs, .modal-details {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .modal-inputs .modal-inputs-category {
        width: calc(100% - 19.2px);
        font-weight: bold;
    }

    .modal-details .modal-details-category {
        width: calc(100% - 12.8px);
        font-weight: bold;
    }

    .modal-inputs .modal-inputs-category + div, .modal-details .modal-details-category + div {
        padding-left: 5px;
    }

    .modal-inputs input, .modal-details input {
        width: 70%;
        font-size: 11px;
        padding: 3px 4px;
    }

    .modal-inputs select, .modal-details select {
        font-size: 11px;
    }

    .modal-inputs textarea, .modal-details textarea {
        width: calc(100% - 9.6px);
    }
}

@media (max-width: 280px) {
    .modal .header {
        font-size: 11.2px;
    }

    .modal .content {
        font-size: 8px;
    }

    .modal .content .modal_smith_logo {
        width: 100px;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B,EAAE,UAAU;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,uCAAuC;IACvC,gBAAgB;IAChB,kDAAkD;AACtD;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,SAAS;IACT,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,uBAAkB;IAAlB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;QAC1B,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".modal-wrapper {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5); /* 흐린 배경 */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 999;\n}\n\n.modal {\n    background: #fff;\n    width: 70%;\n    max-width: 1300px;\n    height: 80%;\n    max-height: 720px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);\n    overflow: hidden;\n    animation: slide-up-fade-in 0.3s ease-out forwards;\n}\n\n.modal .header {\n    position: sticky;\n    top: 0;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: #414141;\n    color: white;\n    font-size: 17.6px;\n    padding: 0 16px;\n}\n\n.modal .close {\n    line-height: 150%;\n    height: 21px;\n    transform: scale(2);\n    cursor: pointer;\n}\n\n.modal .close:hover {\n    transform: scale(1.9);\n    cursor: pointer;\n}\n\n.modal .content {\n    text-align: left;\n    padding: 16px;\n    font-size: 13px;\n    line-height: 160%;\n    overflow-y: scroll;\n    max-height: calc(100% - 90px);\n}\n\n.modal .content .modal_smith_logo {\n    width: 261px;\n}\n\n.modal .content .caution {\n    font-size: 12px;\n    margin: 0;\n    color: red;\n    padding-left: 1.6px;\n}\n\n@keyframes slide-up-fade-in {\n    from {\n        transform: translateY(30px);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.modal-details {\n    display: grid;\n    row-gap: 12.8px;\n    column-gap: 16px;\n    grid-template-columns: 1fr 4fr;\n    align-items: center;\n}\n\n.modal-details .modal-details-category {\n    background-color: #F5F5F5;\n    padding: 6.4px;\n    margin: 0 0 auto 0;\n}\n\n.modal-inputs select, .modal-details select {\n    margin-right: 16px;\n}\n\n.modal-inputs {\n    display: grid;\n    width: 100%;\n    grid-template-columns: 1fr 6fr;\n    row-gap: 12.8px;\n    column-gap: 25.6px;\n    align-items: center;\n}\n\n.modal-inputs .modal-inputs-category {\n    background-color: #F5F5F5;\n    padding: 4.8px 9.6px;\n    margin: 0 0 auto 0;\n}\n\n.modal-inputs input, .modal-details input {\n    width: fit-content;\n    height: 22.4px;\n    padding: 3px 4px;\n    border: 1px solid #dcdcdc;\n}\n\n.modal-inputs select, .modal-details select {\n    width: max-content;\n    min-width: 150px;\n    height: 32px;\n    padding: 2.4px 4.8px;\n    border: 1px solid #dcdcdc;\n}\n\n.modal-inputs textarea, .modal-details textarea {\n    resize: none;\n    border: 1px solid #dcdcdc;\n    padding: 4.8px;\n}\n\n@media screen and (max-width: 900px) {\n    .modal {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 600px) {\n    .modal {\n        height: 60%;\n    }\n\n    .modal .header {\n        font-size: 16px;\n    }\n\n    .modal .content .modal_smith_logo {\n        width: 180px;\n    }\n\n    .modal .content .caution {\n        font-size: 11px;\n    }\n\n    .modal-inputs, .modal-details {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .modal-inputs .modal-inputs-category {\n        width: calc(100% - 19.2px);\n        font-weight: bold;\n    }\n\n    .modal-details .modal-details-category {\n        width: calc(100% - 12.8px);\n        font-weight: bold;\n    }\n\n    .modal-inputs .modal-inputs-category + div, .modal-details .modal-details-category + div {\n        padding-left: 5px;\n    }\n\n    .modal-inputs input, .modal-details input {\n        width: 70%;\n        font-size: 11px;\n        padding: 3px 4px;\n    }\n\n    .modal-inputs select, .modal-details select {\n        font-size: 11px;\n    }\n\n    .modal-inputs textarea, .modal-details textarea {\n        width: calc(100% - 9.6px);\n    }\n}\n\n@media (max-width: 280px) {\n    .modal .header {\n        font-size: 11.2px;\n    }\n\n    .modal .content {\n        font-size: 8px;\n    }\n\n    .modal .content .modal_smith_logo {\n        width: 100px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
